export default __webpack_public_path__ + "static/media/mealcompass_logo.132e4127.png";